var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".user-svg{fill:none;}.user-svg2{fill:url(#linear-gradient-user-svg);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-user-svg",
    x1: -1250.44,
    y1: 299.36,
    x2: -1249.59,
    y2: 300,
    gradientTransform: "matrix(22, 0, 0, -14, 27515.14, 4207.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#345b82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b81a1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "user-svg",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "user-svg2",
    d: "M16,11a3,3,0,1,0-3-3,3,3,0,0,0,3,3ZM8,11A3,3,0,1,0,5,8a3,3,0,0,0,3,3Zm0,2c-2.33,0-7,1.17-7,3.5V18a1,1,0,0,0,1,1H14a1,1,0,0,0,1-1V16.5C15,14.17,10.33,13,8,13Zm8,0c-.29,0-.62,0-1,.05l0,0A4.15,4.15,0,0,1,17,16.5V18a2.85,2.85,0,0,1-.18,1H22a1,1,0,0,0,1-1V16.5C23,14.17,18.33,13,16,13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.3314395a.svg";
export { ForwardRef as ReactComponent };